import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { FormattedHTMLMessage } from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner';
import AttributeOptions from './AttributeOptions.js';
import RenderField from './RenderField';
import CustomAlert from '../components/CustomAlert.js';

class InsuranceForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            beneficiary_count: 1,
            selected_percentage: null
        };
        this.handlePercentageChange = this.handlePercentageChange.bind(this);
        this.renderBeneficiaryFields = this.renderBeneficiaryFields.bind(this);
    }

    handlePercentageChange(value) {
        const percentage = parseInt(value, 10);
        let newCount = 1;

        if (percentage === 50) {
            newCount = 2;
        } else if (percentage === 33) {
            newCount = 3;
        }

        // Clear fields for removed beneficiaries
        if (newCount < this.state.beneficiary_count) {
            const fieldsToDelete = ['name', 'document', 'birth_date', 'phone', 'address', 'relationship', 'percentage'];
            for (let i = newCount + 1; i <= this.state.beneficiary_count; i++) {
                fieldsToDelete.forEach(field => {
                    this.props.deleteReduxFormField(`beneficiary_${i}_${field}`);
                });
            }
        }

        // Set the same percentage for other beneficiaries
        if (newCount >= 2) {
            this.props.setReduxFormField('beneficiary_2_percentage', percentage);
        }
        if (newCount >= 3) {
            this.props.setReduxFormField('beneficiary_3_percentage', percentage);
        }

        this.setState({ beneficiary_count: newCount, selected_percentage: percentage });
    }

    renderBeneficiaryFields(beneficiaryNumber, relationshipOptions, percentageOptions, lockedPercentage) {
        const isFirst = beneficiaryNumber === 1;

        // Get display text for locked percentage
        const getPercentageDisplay = (value) => {
            const option = percentageOptions.find(opt => opt.id === value);
            return option ? option.name : '';
        };

        return (
            <div key={beneficiaryNumber} className="beneficiary-section">
                <h4 className="beneficiary-title">Beneficiario {beneficiaryNumber}</h4>
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-6">
                        <div className="form-group">
                            <Field
                                className="form-control"
                                name={`beneficiary_${beneficiaryNumber}_name`}
                                component={RenderField}
                                type="text"
                                label="Apellido y Nombre"
                            />
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6">
                        <div className="form-group">
                            <Field
                                className="form-control"
                                name={`beneficiary_${beneficiaryNumber}_document`}
                                component={RenderField}
                                type="number"
                                label="Numero de Documento"
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-6">
                        <div className="form-group">
                            <Field
                                className="form-control"
                                name={`beneficiary_${beneficiaryNumber}_birth_date`}
                                component={RenderField}
                                type="text"
                                label="Fecha de Nacimiento (DD/MM/AAAA)"
                            />
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6">
                        <div className="form-group">
                            <Field
                                className="form-control"
                                name={`beneficiary_${beneficiaryNumber}_phone`}
                                component={RenderField}
                                type="number"
                                label="Celular"
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <div className="form-group">
                            <Field
                                className="form-control"
                                name={`beneficiary_${beneficiaryNumber}_address`}
                                component={RenderField}
                                type="text"
                                label="Domicilio"
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-6">
                        <div className="form-group">
                            <AttributeOptions
                                name={`beneficiary_${beneficiaryNumber}_relationship`}
                                defaultValue="Parentesco"
                                label="Parentesco"
                                attributeName={`beneficiary_${beneficiaryNumber}_relationship`}
                                attributeOptions={relationshipOptions}
                            />
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6">
                        <div className="form-group">
                            {isFirst ? (
                                <AttributeOptions
                                    name={`beneficiary_${beneficiaryNumber}_percentage`}
                                    defaultValue="% Beneficiario"
                                    label="% Beneficiario"
                                    attributeName={`beneficiary_${beneficiaryNumber}_percentage`}
                                    attributeOptions={percentageOptions}
                                    onChange={this.handlePercentageChange}
                                />
                            ) : (
                                <div>
                                    <label>% Beneficiario</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={getPercentageDisplay(lockedPercentage)}
                                        disabled
                                    />
                                    <Field
                                        name={`beneficiary_${beneficiaryNumber}_percentage`}
                                        component="input"
                                        type="hidden"
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;

        const relationshipOptions = [
            { id: 'Padre', name: 'Padre' },
            { id: 'Madre', name: 'Madre' },
            { id: 'Hijo/a', name: 'Hijo/a' },
            { id: 'Hermano/a', name: 'Hermano/a' },
            { id: 'Cónyuge',  name: 'Cónyuge' }
        ];

        const percentageOptions = [
            { id: 100, name: '100%' },
            { id: 50, name: '50%' },
            { id: 33, name: '33%' }
        ];

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)} />
                        <FormattedHTMLMessage id="app.step_insurance" description="Insurance info" />
                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable" />
                    </div>
                    <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveInsurance)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos procesando tu solicitud. Por favor espera...' />}
                            {error && <CustomAlert bsStyle="danger" message={error} />}

                            {this.renderBeneficiaryFields(1, relationshipOptions, percentageOptions, null)}
                            {this.state.beneficiary_count >= 2 && this.renderBeneficiaryFields(2, relationshipOptions, percentageOptions, this.state.selected_percentage)}
                            {this.state.beneficiary_count >= 3 && this.renderBeneficiaryFields(3, relationshipOptions, percentageOptions, this.state.selected_percentage)}

                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Seguir</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

InsuranceForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

const validate = (values) => {
    let errors = {};
    const fields = ['name', 'document', 'birth_date', 'phone', 'address', 'relationship', 'percentage'];

    // Always validate first beneficiary
    fields.forEach(field => {
        const fieldName = `beneficiary_1_${field}`;
        if (!values[fieldName] || values[fieldName] === 'false') {
            errors[fieldName] = 'Este Campo es Obligatorio';
        }
    });

    // Validate additional beneficiaries based on percentage
    const percentage = parseInt(values.beneficiary_1_percentage, 10);
    let count = 1;
    if (percentage === 50) count = 2;
    if (percentage === 33) count = 3;

    for (let i = 2; i <= count; i++) {
        fields.forEach(field => {
            const fieldName = `beneficiary_${i}_${field}`;
            if (!values[fieldName] || values[fieldName] === 'false') {
                errors[fieldName] = 'Este Campo es Obligatorio';
            }
        });
    }

    return errors;
};

InsuranceForm = TopScrolleable(InsuranceForm);

InsuranceForm = reduxForm({
    form: 'InsuranceForm',
    validate
})(InsuranceForm);

InsuranceForm = withAuthControl(InsuranceForm);

export default InsuranceForm;



/** WEBPACK FOOTER **
 ** ./src/components/InsuranceForm.js
 **/